import { Slide } from 'pure-react-carousel';
import buildImageSrc from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { MediaType } from '@repo/ui/src/types/image';
import { LinkProps } from '@repo/ui/src/types/link';
import Image from '@repo/ui/src/components/Image/New';

interface Props {
  slide: {
    image?: MediaType;
    link?: LinkProps;
  };
  index: number;
}

const LogoSlide = ({ slide: { image, link }, index }: Props) => {
  const Element = link ? Anchor : 'div';
  return (
    <Slide index={index}>
      <Element
        className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:-tw-outline-offset-2"
        {...(link ?? {})}
        tabIndex={0}
      >
        <Image src={buildImageSrc(image)} width={150} height={150} alt={image?.name || 'logo'} />
      </Element>
    </Slide>
  );
};

export default LogoSlide;
